export default {"src":"/_next/static/media/errorimg.bfb57aae.svg","height":932,"width":1364,"blurWidth":0,"blurHeight":0};